import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { DBDef_AdvisorWizard } from '@app/advisor-content-shared';
import { createWorkHubManager } from '@app/styles';
import { ModuleFE_AdvisorWizard } from '../../../_entity/wizard/ModuleFE_AdvisorWizard.js';
import { Renderer_AdvisorWizardHeader } from './renderers/Renderer_AdvisorWizardHeader/Renderer_AdvisorWizardHeader.js';
import { Editor_AdvisorWizard } from '../../advisor-context-editor/editors/Editor_AdvisorWizard.js';
import './Manager_AdvisorWizard.scss';
import { LL_V_L } from "@nu-art/thunderstorm-frontend";
const Editor_AdvisorWizard_Wrapper = (props) => {
    return (_jsxs(LL_V_L, { className: 'manager-advisor-wizard', children: [_jsx(Renderer_AdvisorWizardHeader, { workHubItem: props.workHubItem, renderArgs: props.renderArgs }), _jsx(Editor_AdvisorWizard, { editable: props.editable, editMode: props.renderArgs.editMode, hideHeader: true })] }));
};
export const Manager_AdvisorWizard = createWorkHubManager({
    module: ModuleFE_AdvisorWizard,
    dbDef: DBDef_AdvisorWizard,
    defaultItem: {},
    labelResolver: (wizard) => wizard.label ?? "New Wizard",
    EditorComponent: Editor_AdvisorWizard_Wrapper,
});
//# sourceMappingURL=Manager_AdvisorWizard.js.map